import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 懒加载写法
const login = () => import('@/views/Login.vue')
const mainLayout = () => import('@/layouts/MainLayout.vue')

// ======= 首页 =========
const homeView = () => import('@/views/Home.vue')
const surveyView = () => import('@/views/Survey.vue')
const transcriptionView = () => import('@/views/Transcription.vue')
const encodingView = () => import('@/views/Encoding.vue')
const usercenterView = () => import('@/views/userCenter/Index.vue')
const orderView = () => import('@/views/userCenter/Orders.vue')
const settingView = () => import('@/views/userCenter/Setting.vue')
const agreementView = () => import('@/views/Agreement.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    name: 'layout',
    component: mainLayout,
    redirect: '/home',
    children: [
      // ======== 首页 ========
      {
        path: 'home',
        name: 'home',
        component: homeView,
        meta: { title: '首页' }
      },
      {
        path: 'survey',
        name: 'survey',
        component: surveyView,
        meta: { title: '访谈调研' }
      },
      {
        path: 'transcription',
        name: 'transcription',
        component: transcriptionView,
        meta: { title: '语音转录' }
      },
      {
        path: 'encoding',
        name: 'encoding',
        component: encodingView,
        meta: { title: '人工编码' }
      },
      {
        path: '/usercenter',
        name: 'usercenter',
        component: usercenterView,
        redirect: '/usercenter/setting',
        children: [
          // ======== 首页 ========
          {
            path: 'setting',
            name: 'setting',
            component: settingView,
            meta: { title: '设置账号' }
          },
          {
            path: 'order',
            name: 'order',
            component: orderView,
            meta: { title: '订单中心' }
          }
        ]
      },
      {
        path: 'agreement',
        name: 'agreement',
        component: agreementView,
        meta: { title: '协议' }
      }
      // [代码修改] 将 nvivo 相关路由移出 children，作为顶级路由，以避免显示 MainLayout 的 Header
      // (保持原样)
    ]
  },
  // [代码新增] 将 nvivo 页面作为顶级路由，它们拥有自己独立的布局和头部，不应被包含在 MainLayout 中
  // (保持原样)
  {
    path: '/nvivo',
    name: 'nvivo_HomePage',
    component: () => import('@/views/clientView/HomePage.vue')
  },
  {
    path: '/nvivo/loading',
    name: 'nvivo_Loading',
    component: () => import('@/views/clientView/LoadingPage.vue')
  },
  {
    path: '/nvivo/payment',
    name: 'nvivo_Payment',
    component: () => import('@/views/clientView/PaymentPage.vue')
  },
  // 营销页（顶级路由，各自挂统一顶栏，不含 MainLayout）
  {
    path: '/membership',
    name: 'nvivo_Membership',
    component: () => import('@/views/clientView/Membership.vue'),
    meta: { title: '会员中心' }
  },
  {
    path: '/private-deployment',
    name: 'nvivo_PrivateDeployment',
    component: () => import('@/views/clientView/PrivateDeployment.vue'),
    meta: { title: '私有部署' }
  }
]

const router = new VueRouter({
  mode: 'hash', // 如果服务器未配置 History fallback，请改为 'hash'
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // 路由切换滚动到页面顶部
    return { x: 0, y: 0 }
  }
})

// ✨【已修改】
// 移除了此处根据域名硬编码修改页面标题的逻辑。
// 该逻辑已在 App.vue 的 loadSiteSettings 方法中实现，
// App.vue 会在加载时从 API 获取 site_title 并设置 document.title，
// 此处无需重复操作，否则会覆盖动态设置的标题。
router.beforeEach((to, from, next) => {
  // --- 【代码修改开始】 ---
  // (已移除所有硬编码设置 title 的 if/else 逻辑)
  // --- 【代码修改结束】 ---
  next()
})

export default router